
export default function getViewport () {
  const win = window;
  const doc = document;
  const el = doc.documentElement;
  const body = doc.getElementsByTagName('body')[0];
  const width = win.innerWidth || el.clientWidth || body.clientWidth;
  const height = win.innerHeight || el.clientHeight || body.clientHeight;

  return { width, height };
}
